export enum MenuPermissionsEnum {
  MenuAgroAnalytics = "CYS_MENU_ANLYT_AGRI",
  MenuAnalytics = "CYS_MENU_ANLYT_DEFLT",
  MenuNatcatAnalytics = "CYS_MENU_ANLYT_NATCAT",
  MenuClaimsAgriculture = "CYS_MENU_CLAIM_AGRI",
  MenuClaimsBuildings = "CYS_MENU_CLAIM_BLDG",
  MenuDashboardKpi = "CYS_MENU_DASHB_KPIS",
  MenuEmergencyMonitoring = "CYS_MENU_EMMON",
  MenuMiningAssets = "CYS_MENU_ASSET_MINING",
  MenuPoliciesAgriculture = "CYS_MENU_POLIC_AGRI",
  MenuPoliciesBuildings = "CYS_MENU_POLIC_BLDG",
  MenuRiskAssessment = "CYS_MENU_RISKA",
  MenuRiskIndex = "CYS_MENU_RISKI",
  MenuSettings = "CYS_MENU_SETUP",

  //CYS_ANALYTICS_ANIA
  // rmaRiskWindItaAnia = "RMA_RISK_WINDY_ITA_ANIA",
  // rmaRiskHailsItaAnia = "RMA_RISK_HAILS_ITA_ANIA",
  // rmaRiskLightningItaAnia = "RMA_RISK_LGTNG_ITA_ANIA",
  // rmaRiskSnowItaAnia = "RMA_RISK_SNOWF_ITA_ANIA",
  // rmaRiskPrecipitationsItaAnia = "RMA_RISK_PRECP_ITA_ANIA",
}
